export type SessionClaims = {
  userId: number | null;
  tenantGuid: string | null;
  email: string | null;
  role: string | null;
  companyCode?: string | null;
};

/** Decode JWT payload without verifying signature (client session hydration only). */
export function decodeAccessTokenClaims(accessToken: string): SessionClaims {
  try {
    const parts = accessToken.split('.');
    if (parts.length < 2) return emptyClaims();

    const json = atob(parts[1].replace(/-/g, '+').replace(/_/g, '/'));
    const payload = JSON.parse(json) as Record<string, unknown>;

    const sub = payload['sub'];
    const userId =
      typeof sub === 'string' || typeof sub === 'number' ? Number(sub) : null;

    return {
      userId: Number.isFinite(userId) && userId! > 0 ? userId : null,
      tenantGuid: readString(payload['tenant_guid'] ?? payload['tenantGuid']),
      email: readString(payload['email']),
      role: readString(payload['role']),
      companyCode: null,
    };
  } catch {
    return emptyClaims();
  }
}

function readString(value: unknown): string | null {
  return typeof value === 'string' && value.trim() ? value.trim() : null;
}

function emptyClaims(): SessionClaims {
  return { userId: null, tenantGuid: null, email: null, role: null, companyCode: null };
}
